import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import TextInputField from "../../forms/TextInputField";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {cancelRenameWarehouse, renameWarehouse} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand, getWarehouseWithId} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "location");
  return errors.toJS();
}

class RenameWarehouseForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Warehouse"
              name="id"
              active={false}
              component={TextInputField}
              />
            <Field 
              label="Location"
              name="location"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelRenameWarehouse} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RenameWarehouseForm",
  validate: validateForm
})(RenameWarehouseForm);

const ConnectedForm = connect(
  (state, ownProps) => ({
    submitInfo: getSubmitInfoForCommand(state.get("inventory"), "RenameWarehouse"),
    initialValues: {
      id: ownProps.id,
      location: getWarehouseWithId(state.get("inventory"), ownProps.id).get("location")
    }
  }),
  {
    cancelRenameWarehouse,
    submit,
    onSubmit: (data) => renameWarehouse(data)
  }
)(ReduxForm);

export default ConnectedForm;